import { render, staticRenderFns } from "./chapter-question.vue?vue&type=template&id=713d949a"
import script from "./chapter-question.vue?vue&type=script&lang=js"
export * from "./chapter-question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports